import React from 'react';
import { Alert } from '@one-thd/sui-atomic-components';
import { TECHNICAL_ERROR_MSG } from '../../../constants/alert-messages';

export const ErrorMessage = () => {
  return <Alert status="error">{TECHNICAL_ERROR_MSG}</Alert>;
};
